import AsignacionItems from "../modules/asignacionItems/AsignacionItems.vue"
import Caja from "../modules/caja/Caja.vue"
import RegistrarCaja from "../modules/caja/RegistrarCaja.vue"
import VerCaja from "../modules/caja/VerCaja.vue"
import Cliente from "../modules/cliente/Cliente.vue"
import Empleado from "../modules/empleado/Empleado.vue"
import Envios from "../modules/envio/Envios.vue"
import Inventario from "../modules/inventario/Inventario.vue"
import Mixers from "../modules/mixer/Mixer.vue"
import OrdenPago from "../modules/ordenPago/OrdenPago.vue"
import OrdenVenta from "../modules/ordenVenta/OrdenVenta.vue"
import PedidoItems from "../modules/pedidoItem/PedidoItems.vue"
import ProductoList from "../modules/producto/Producto.vue"
import ProductoVenta from "../modules/productoVenta/ProductoVenta.vue"
import CrearCuenta from "../modules/proveedor/CrearCuenta.vue"
import ProveedorOrdenCompra from "../modules/proveedor/ProveedorOrdenCompra.vue"
import ProyectoList from "../modules/proyecto/ProyectoList.vue"
import RendicionNew from "../modules/rendicion/RendicionNew.vue"
import TransferenciaItems from "../modules/transferenciaItems/TransferenciaItems.vue"
import Usuario from "../modules/usuario/Usuario.vue"
import Vendedor from "../modules/vendedor/Vendedor.vue"
import CentroCostoList from "../components/CentroCostoList.vue"
import ChangePassword from "../components/ChangePassword.vue"
import Forbidden from "../components/Forbidden.vue"
import Home from "../components/Home.vue"
import Login from "../components/Login.vue"
import MarcaList from "../components/MarcaList.vue"
import OrdenApprove from "../components/OrdenApprove.vue"
import OrdenEdit from "../components/OrdenEdit.vue"
import OrdenImportacion from "../components/OrdenImportacion.vue"
import OrdenList from "../components/OrdenList.vue"
import OrdenListApprove from "../components/OrdenListApprove.vue"
import OrdenMassive from "../components/OrdenMassive.vue"
import OrdenNew from "../components/OrdenNew.vue"
import OrdenRestart from "../components/OrdenRestart.vue"
import OrdenView from "../components/OrdenView.vue"
import PriceSearch from "../components/PriceSearch.vue"
import ProveedorList from "../components/ProveedorList.vue"
import RenovateStock from "../components/RenovateStock.vue"
import UnidadList from "../components/UnidadList.vue"
import { ModulesEnum } from "../constants"

const RoutesEnum = {
    Login: {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            module: ModulesEnum.LOGIN
        }
    },
    LoginAndEmail: {
        path: "/login/:email",
        name: "LoginAndEmail",
        component: Login,
        meta: {
            module: ModulesEnum.LOGIN
        }
    },
    OrdenList: {
        path: "/orden",
        name: "OrdenList",
        component: OrdenList,
        meta: {
            module: ModulesEnum.ORDEN_COMPRA
        }
    },
    OrdenMassive: {
        path: "/orden/massive",
        name: "OrdenMassive",
        component: OrdenMassive,
        meta: {
            module: ModulesEnum.ORDEN_COMPRA,
        }
    },
    OrdenNew: {
        path: "/orden/new",
        name: "OrdenNew",
        component: OrdenNew,
        meta: {
            module: ModulesEnum.ORDEN_COMPRA,
        }
    },
    OrdenView: {
        path: "/orden/view/:id",
        name: "OrdenView",
        component: OrdenView,
        meta: {
            module: ModulesEnum.ORDEN_COMPRA
        }
    },
    OrdenEdit: {
        path: "/orden/edit/:id",
        name: "OrdenEdit",
        component: OrdenEdit,
        meta: {
            module: ModulesEnum.ORDEN_COMPRA
        }
    },
    CentroCostoList: {
        path: "/centroCosto",
        name: "CentroCostoList",
        component: CentroCostoList,
        meta: {
            module: ModulesEnum.CENTRO_COSTO
        }
    },
    UnidadList: {
        path: "/unidad",
        name: "UnidadList",
        component: UnidadList,
        meta: {
            module: ModulesEnum.UNIDAD
        }
    },
    MarcaList: {
        path: "/marca",
        name: "MarcaList",
        component: MarcaList,
        meta: {
            module: ModulesEnum.MARCA
        }
    },
    ProveedorList: {
        path: "/proveedor",
        name: "ProveedorList",
        component: ProveedorList,
        meta: {
            module: ModulesEnum.PROVEEDOR
        }
    },
    Usuario: {
        path: "/usuario",
        name: "Usuario",
        component: Usuario,
        meta: {
            module: ModulesEnum.USUARIO
        }
    },
    PriceSearch: {
        path: "/search",
        name: "PriceSearch",
        component: PriceSearch,
        meta: {
            module: ModulesEnum.ORDEN_COMPRA,
        }
    },
    OrdenListApprove: {
        path: "/orden/approve",
        name: "OrdenListApprove",
        component: OrdenListApprove,
        meta: {
            module: ModulesEnum.ORDEN_COMPRA,
        }
    },
    OrdenApprove: {
        path: "/orden/approve/:id",
        name: "OrdenApprove",
        component: OrdenApprove,
        meta: {
            module: ModulesEnum.ORDEN_COMPRA,
        }
    },
    OrdenImportacion: {
        path: "/orden/importacion/:id",
        name: "OrdenImportacion",
        component: OrdenImportacion,
        meta: {
            module: ModulesEnum.ORDEN_COMPRA,
        }
    },
    OrdenRestart: {
        path: "/orden/restart/:id",
        name: "OrdenRestart",
        component: OrdenRestart,
        meta: {
            module: ModulesEnum.ORDEN_COMPRA,
        }
    },
    RenovateStock: {
        path: "/renovate",
        name: "RenovateStock",
        component: RenovateStock,
        meta: {
            module: ModulesEnum.ORDEN_COMPRA,
        }
    },
    ChangePassword: {
        path: "/user/change-password",
        name: "ChangePassword",
        component: ChangePassword,
        meta: {
            module: ModulesEnum.USUARIO,
        }
    },
    ProductoList: {
        path: "/producto",
        name: "ProductoList",
        component: ProductoList,
        meta: {
            module: ModulesEnum.PRODUCTO
        }
    },
    Caja: {
        path: "/caja",
        name: "Caja",
        component: Caja,
        meta: {
            module: ModulesEnum.CAJA
        }
    },
    RegistrarCaja: {
        path: "/caja/new",
        name: "RegistrarCaja",
        component: RegistrarCaja,
        meta: {
            module: ModulesEnum.CAJA,
        }
    },
    VerCaja: {
        path: "/caja/view/:id",
        name: "VerCaja",
        component: VerCaja,
        meta: {
            module: ModulesEnum.CAJA,
        }
    },
    ModificarCaja: {
        path: "/caja/edit/:id",
        name: "ModificarCaja",
        component: RegistrarCaja,
        meta: {
            module: ModulesEnum.CAJA,
        }
    },
    RendicionNew: {
        path: "/rendicion/new/:id/:codigo",
        name: "RendicionNew",
        component: RendicionNew,
        meta: {
            module: ModulesEnum.CAJA,
        }
    },
    OrdenPago: {
        path: "/ordenPago/:ord_id",
        name: "ordenPago",
        component: OrdenPago,
        meta: {
            module: ModulesEnum.ORDEN_PAGO,
        }
    },
    verOrdenPago: {
        path: "/ordenPago/:ord_id/:interfaz/:opg_id",
        name: "verOrdenPago",
        component: OrdenPago,
        meta: {
            module: ModulesEnum.ORDEN_PAGO,
        }
    },
    ProyectoList: {
        path: "/proyecto",
        name: "ProyectoList",
        component: ProyectoList,
        meta: {
            module: ModulesEnum.PROYECTO,
        }
    },
    Empleado: {
        path: "/empleado",
        name: "Empleado",
        component: Empleado,
        meta: {
            module: ModulesEnum.EMPLEEADO,
        }
    },
    AsignacionItems: {
        path: "/asignaciones",
        name: "AsignacionItems",
        component: AsignacionItems,
        meta: {
            module: ModulesEnum.ASIGNACION_ITEMS,
        }
    },
    TransferenciaItemsList: {
        path: "/transferencia",
        name: "TransferenciaItemsList",
        component: TransferenciaItems,
        meta: {
            module: ModulesEnum.TRANSFERENCIA_ITEMS,
        }
    },
    Inventario: {
        path: "/inventario",
        name: "Inventario",
        component: Inventario,
        meta: {
            module: ModulesEnum.INVENTARIO,
        }
    },
    Cliente: {
        path: "/cliente",
        name: "cliente",
        component: Cliente,
        meta: {
            module: ModulesEnum.CLIENTE,
        }
    },
    ProductoVenta: {
        path: "/productoVenta",
        name: "productoVenta",
        component: ProductoVenta,
        meta: {
            module: ModulesEnum.PRODUCTO_VENTA,
        }
    },
    OrdenVenta: {
        path: "/ordenVenta",
        name: "ordenVenta",
        component: OrdenVenta,
        meta: {
            module: ModulesEnum.ORDEN_VENTA,
        }
    },
    Envios: {
        path: "/envios",
        name: "envios",
        component: Envios,
        meta: {
            module: ModulesEnum.ENVIO,
        }
    },
    Mixers: {
        path: "/mixers",
        name: "mixers",
        component: Mixers,
        meta: {
            module: ModulesEnum.MIXER,
        }
    },
    Vendedor: {
        path: "/vendedor",
        name: "vendedor",
        component: Vendedor,
        meta: {
            module: ModulesEnum.VENDEDOR,
        }
    },
    PedidoItems: {
        path: "/pedidoItems",
        name: "pedidoItems",
        component: PedidoItems,
        meta: {
            module: ModulesEnum.PEDIDO_ITEMS,
        }
    },
    VerPedidoItems: {
        path: "/pedidoItems/:action/:id",
        name: "verPedidoItems",
        component: PedidoItems,
        meta: {
            module: ModulesEnum.PEDIDO_ITEMS,
        }
    },
    CrearCuenta: {
        path: "/proveedor/crearCuenta",
        name: "CrearCuenta",
        component: CrearCuenta,
        meta: {
            module: ModulesEnum.CREAR_CUENTA,
        }
    },
    ProveedorOrdenCompra: {
        path: "/proveedor/ordenCompra",
        name: "ProveedorOrdenCompra",
        component: ProveedorOrdenCompra,
        meta: {
            module: ModulesEnum.PROVEEDOR_ORDEN_COMPRA,
        }
    },
    Home: {
        path: "/home",
        name: "Home",
        component: Home,
        meta: {
            module: ModulesEnum.HOME,
        }
    },
    Forbidden: {
        path: "/forbidden",
        name: "Forbidden",
        component: Forbidden
    },
    getRoutes: () => {
        return [
            RoutesEnum.Login,
            RoutesEnum.LoginAndEmail,
            RoutesEnum.OrdenList,
            RoutesEnum.OrdenMassive,
            RoutesEnum.OrdenNew,
            RoutesEnum.OrdenView,
            RoutesEnum.OrdenEdit,
            RoutesEnum.CentroCostoList,
            RoutesEnum.UnidadList,
            RoutesEnum.MarcaList,
            RoutesEnum.ProveedorList,
            RoutesEnum.Usuario,
            RoutesEnum.PriceSearch,
            RoutesEnum.OrdenListApprove,
            RoutesEnum.OrdenApprove,
            RoutesEnum.OrdenImportacion,
            RoutesEnum.OrdenRestart,
            RoutesEnum.RenovateStock,
            RoutesEnum.ChangePassword,
            RoutesEnum.ProductoList,
            RoutesEnum.Caja,
            RoutesEnum.RegistrarCaja,
            RoutesEnum.VerCaja,
            RoutesEnum.ModificarCaja,
            RoutesEnum.RendicionNew,
            RoutesEnum.OrdenPago,
            RoutesEnum.verOrdenPago,
            RoutesEnum.ProyectoList,
            RoutesEnum.Empleado,
            RoutesEnum.AsignacionItems,
            RoutesEnum.TransferenciaItemsList,
            RoutesEnum.Inventario,
            RoutesEnum.Cliente,
            RoutesEnum.ProductoVenta,
            RoutesEnum.OrdenVenta,
            RoutesEnum.Envios,
            RoutesEnum.Mixers,
            RoutesEnum.Vendedor,
            RoutesEnum.PedidoItems,
            RoutesEnum.VerPedidoItems,
            RoutesEnum.CrearCuenta,
            RoutesEnum.ProveedorOrdenCompra,
            RoutesEnum.Home,
            RoutesEnum.Forbidden,
        ]
    }
}

export default RoutesEnum